<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="contentBox w">
      <div class="contentStitle">Contact Us</div>
      <div class="contentTitle">联系我们</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="adress">
        <div class="titleBox">
          <div class="adressLine"></div>
          <div class="adressTitle">总部地址</div>
        </div>

        <div class="adressItem">
          <div class="itemLeft">
            <img :src="src.contactUs" alt />
          </div>
          <div class="itemRight">
            <p>深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心</p>
            <p>邮箱：yjhhr@yjhhr.cn</p>
            <p>联系人：人事经理</p>
            <p>联系电话：0755-23209701</p>
          </div>
        </div>
      </div>
<!--      <div class="mendian" v-if="false">-->
<!--        <div class="titleBox">-->
<!--          <div class="adressLine"></div>-->
<!--          <div class="adressTitle">门店地址</div>-->
<!--        </div>-->
<!--        <div class="mdItem">-->
<!--          <div class="item" v-for="(item, index) in itemArr" :key="index">-->
<!--            <div class="imgBox">-->
<!--              <img :src="item.img" alt />-->
<!--            </div>-->
<!--            <div class="itemDetails">-->
<!--              <div class="delTitle">{{ item.title }}</div>-->
<!--              <div>地址：{{ item.address }}</div>-->
<!--              <div>手机：{{ item.mobile }} {{ item.linkman }}</div>-->
<!--              &lt;!&ndash; <div>{{ item.mail }}</div> &ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">联系我们</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">总部地址</div>
        </div>
      </div>
      <div class="address_item">
        <div class="item_left">
          <img :src="src.contactUsMobile" alt="" />
        </div>
        <div class="item_right">
          <p>深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心</p>
          <p>邮箱：yjhhr@yjhhr.cn</p>
          <p>联系人：人事经理</p>
          <p>联系电话：0755-23209701</p>
        </div>
      </div>
<!--      <div class="mobile_yjh_item">-->
<!--        <div class="mobile_yjh_item_text">-->
<!--          <div class="text_line"></div>-->
<!--          <div class="text_title">门市地址</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="mdItem">-->
<!--        <div class="item" v-for="(item, index) in itemArr" :key="index">-->
<!--          <div class="imgBox">-->
<!--            <img :src="item.img" alt />-->
<!--          </div>-->
<!--          <div class="itemDetails">-->
<!--            <div class="delTitle">{{ item.title }}</div>-->
<!--            <div>地址：{{ item.address }}</div>-->
<!--            <div>手机：{{ item.mobile }} {{ item.linkman }}</div>-->
<!--            &lt;!&ndash; <div>邮箱：{{ item.mail }}</div> &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import axios from "axios";
import src from "../../utils/assets";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  props: ["header"],
  data() {
    return {
      idnex: "6",
      itemArr: [],
      src: src,
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    // store/info
    getNewsList() {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/jiupin/store/info")
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.itemArr = res.data.data;
          }
          for (let i = 0; i < _this.itemArr.length; i++) {
            _this.itemArr[i].img = src.store;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .contentBox {
    display: none;
  }
  .address_item {
    display: flex;
    justify-content: space-around;
    .item_left {
      width: 100px;
      img {
        width: 100%;
      }
    }
    .item_right {
      width: 220px;
      text-align: left;
      padding-top: 10px;
      line-height: 1.5;
    }
  }
  .mdItem {
    padding: 0 10px;
    margin-bottom: 20px;
    .item {
      display: flex;
      margin-top: 10px;
      .imgBox {
        width: 130px;
        text-align: left;
        margin-right: 10px;
        img {
          width: 130px;
          height: 80px;
        }
      }
      .itemDetails {
        width: 210px;
        padding: 10px 10px;
        // font-size: 16px;
        font-family: Microsoft YaHei;
        color: #555555;
        border: 1px solid #cccccc;
        text-align: left;
        line-height: 1.2;
        .delTitle {
          font-weight: bold;
        }
      }
    }
    // .item:nth-child(3n) {
    //   margin-right: 0;
    // }
  }
}
@media screen and (min-width: 1000px) {
  .mobile_contentBox {
    display: none;
  }
  .titleBox {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #c6c6c6;
    display: flex;
    line-height: 60px;
    .adressLine {
      width: 6px;
      height: 20px;
      background-color: #da261d;
      margin: 20px;
    }
    .adressTitle {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
    }
  }
  .adress {
    width: 100%;
    .adressItem {
      display: flex;
      .itemLeft {
        padding: 30px;
      }
      .itemRight {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        text-align: left;
        margin: 50px;
        p {
          line-height: 40px;
        }
      }
    }
  }
  .mendian {
    height: 800px;
    .mdItem {
      padding: 0 10px;
      .item {
        width: 31%;
        float: left;
        margin-right: 30px;
        margin-top: 30px;
        .imgBox {
          text-align: left;
          img {
            width: 100%;
            height: 200px;
          }
        }
        .itemDetails {
          padding: 0 30px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          color: #555555;
          border: 1px solid #cccccc;
          text-align: left;
          line-height: 30px;
          .delTitle {
            font-weight: bold;
          }
        }
      }
      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
